
import { Options, Vue } from 'vue-class-component'
import {
  ObjectTemplate,
  ObjectType,
  StatTypeEnum,
  ObjectTypeEnum,
  RegionType,
  RegionEnum
} from '@cybertale/interface'
import { Inject } from 'vue-property-decorator'
import { $t, Translations } from '@geocms/localization'
interface CodeChallengePair {
  codeVerifier: string;
  codeChallenge: string;
}
@Options({
  computed: {
    $t () {
      return $t
    }
  },
  props: {
    object: ObjectTemplate
  }
})
export default class WelcomeComponent extends Vue {
  @Inject() http: any;
  @Inject() Definitions: any;
  @Inject() router: any;
  @Inject() updateHeaders: any;
  selectedImage = require(`../assets/lang/${localStorage.getItem('lang') || 'en'}.svg`)
  statTypeEnum = StatTypeEnum
  objectTypeEnum = ObjectTypeEnum
  objectType = ObjectType
  regionType = RegionType
  regionEnum = RegionEnum
  object!: ObjectTemplate

  async created (): Promise<void> {
    // Generate code verifier and code challenge
    const nonce = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    console.log('nonce:', nonce)

    // Save clientId and codeVerifier to the Vuex store
    this.generateCodeChallengePair().then((codeChallengePair) => {
      this.$store.commit('setCodeVerifier', codeChallengePair.codeVerifier)
      this.$store.commit('setCodeChallenge', codeChallengePair.codeChallenge)
    })
    this.$store.commit('setClientId', process.env.VUE_APP_CLIENT_ID)
    this.$store.commit('setNonce', nonce)
  }

  async changeLanguage (lang: keyof Translations): Promise<void> {
    localStorage.setItem('lang', lang)
    this.updateHeaders()
    window.location.href = window.location.origin
    this.selectedImage = require(`../assets/lang/${lang}.svg`)
  }

  login (): void {
    const clientId = this.$store.state.clientId
    const redirectUri = process.env.VUE_APP_URL + 'oauth/callback'
    const codeChallenge = this.$store.state.codeChallenge
    const verifier = this.$store.state.codeVerifier
    const nonce = this.$store.state.nonce // Add state parameter
    const query = `client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&code_challenge=${codeChallenge}&verifier=${verifier}&code_challenge_method=S256&state=${nonce}` // Add state parameter to the query string
    // console.log(process.env.VUE_APP_URL + 'oauth/authorize?' + query)
    window.location.href = process.env.VUE_APP_URL + 'oauth/redirect?' + query
  }

  redirectToRegistration () : void {
    const registrationUrl = process.env.VUE_APP_URL + 'register'
    window.open(registrationUrl, '_blank')
  }

  async generateCodeChallengePair (): Promise<CodeChallengePair> {
    const codeVerifierBytes = new Uint8Array(64)
    crypto.getRandomValues(codeVerifierBytes)
    const codeVerifier = btoa(String.fromCharCode.apply(null, Array.from(codeVerifierBytes)))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '')

    const codeChallengeBytes = new TextEncoder().encode(codeVerifier)
    const hashBuffer = await crypto.subtle.digest('SHA-256', codeChallengeBytes)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const codeChallenge = btoa(String.fromCharCode.apply(null, hashArray))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '')
    return {
      codeVerifier,
      codeChallenge
    }
  }
}
